<div class="main-content">
    <div class="container-fluid">
        <div class="row"></div>
        <div class="row"></div>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <div class="card card-chart">
                    <div class="chart-wrapper">
                        <canvas baseChart
                                [data]="doughnutChartData"
                                [type]="doughnutChartType">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
        <div class="row"></div>
    </div>
</div>
